/**
 * Traya header search: icon toggles panel (input + predictive results).
 */
(function () {
  function closeAll() {
    document.querySelectorAll('[data-traya-header-search].is-open').forEach((wrap) => {
      wrap.classList.remove('is-open');
      const panel = wrap.querySelector('[data-traya-search-panel]');
      const toggle = wrap.querySelector('[data-traya-search-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-traya-search-panel]').forEach((panel) => {
      panel.style.top = '';
    });
    document.body.classList.remove('traya-search-open');
    document.querySelectorAll('.traya-header-search__backdrop.active').forEach((el) => {
      el.classList.remove('active');
    });
  }

  function syncMobilePanelTop(wrap) {
    if (!wrap || !wrap.classList.contains('traya-header-search--mobile') || !wrap.classList.contains('is-open')) return;
    const panel = wrap.querySelector('[data-traya-search-panel]');
    const header = document.querySelector('main-header#site-header') || document.getElementById('site-header');
    if (panel && header) {
      panel.style.top = `${Math.ceil(header.getBoundingClientRect().bottom)}px`;
    }
  }

  function openWrap(wrap) {
    closeAll();
    wrap.classList.add('is-open');
    const panel = wrap.querySelector('[data-traya-search-panel]');
    const toggle = wrap.querySelector('[data-traya-search-toggle]');
    if (panel) panel.hidden = false;
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    document.body.classList.add('traya-search-open');
    const backdrop = wrap.querySelector('[data-traya-search-backdrop]');
    if (backdrop) {
      backdrop.classList.add('active');
    }
    syncMobilePanelTop(wrap);
    const input = wrap.querySelector('[data-js-search-input]');
    requestAnimationFrame(() => {
      if (input) input.focus({ preventScroll: true });
    });
  }

  let resizeTimer;
  window.addEventListener(
    'resize',
    () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.querySelectorAll('[data-traya-header-search].is-open').forEach(syncMobilePanelTop);
      }, 100);
    },
    { passive: true }
  );

  document.addEventListener('click', (e) => {
    const fieldIcon = e.target.closest('[data-traya-search-field-icon]');
    if (fieldIcon) {
      const wrap = fieldIcon.closest('[data-traya-header-search]');
      const input = wrap && wrap.querySelector('[data-js-search-input]');
      if (input) {
        e.preventDefault();
        input.focus({ preventScroll: true });
      }
      return;
    }

    const modalClose = e.target.closest('[data-traya-search-close]');
    if (modalClose) {
      e.preventDefault();
      closeAll();
      return;
    }

    const toggle = e.target.closest('[data-traya-search-toggle]');
    if (toggle) {
      e.preventDefault();
      const wrap = toggle.closest('[data-traya-header-search]');
      if (!wrap) return;
      if (wrap.classList.contains('is-open')) {
        closeAll();
      } else {
        openWrap(wrap);
      }
      return;
    }

    const backdrop = e.target.closest('[data-traya-search-backdrop]');
    if (backdrop && backdrop.classList.contains('active')) {
      e.preventDefault();
      closeAll();
      return;
    }

    if (e.target.closest('[data-traya-header-search]')) {
      return;
    }
    closeAll();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

})();
